import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useState } from "react";
import { createGlobalStyle } from "styled-components";
import AboutUs from "./Pages/AboutUs";
import Shop from "./Pages/Shop";
import Product from "./Pages/Product";
import Home from "./Pages/Home";
import ContactUs from "./Pages/ContactUs";
import Registeration from "./Pages/Registeration";
import Account from "./Pages/Account";
import Checkout from "./Pages/Checkout";
import NavBar from "./Components/NavBar/NavBar";
import Footer from "./Components/Footer/Footer";
import PopUp from "./Components/PopUp/PopUp";
import ScrollToTop from "./helpers/ScrollToTop";
import { Toast } from "./Components/Toast/Toast";
import useToast from "./hooks/useToast";

// Global style to disable scrolling when a popup is open
const GlobalStyles = createGlobalStyle`
  body {
    overflow: ${({ $isPopupOpen }) => ($isPopupOpen ? "hidden" : "auto")};
  }
`;

function App() {
  const [popUp, setPopUp] = useState({ isOpen: false, isDesktopOpen: true });
  const { toast, showToast, hideToast } = useToast();
  return (
    <Router>
      <GlobalStyles $isPopupOpen={popUp.isOpen} />
      <ScrollToTop />
      <NavBar setPopUp={setPopUp} />
      {!toast.hidden && (
        <Toast
          top="0"
          message={toast.text}
          title={toast.title}
          type={toast.type}
          position={"sticky"}
          height={"3.5vh"}
          hideToast={hideToast}
        />
      )}
      {popUp.isOpen && <PopUp props={popUp} setPopUp={setPopUp} />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route
          path="/shop"
          element={<Shop fltrBarProps={popUp} setFltrBar={setPopUp} />}
        />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route
          path="/cart"
          element={<Checkout setPopUp={setPopUp} showParentToast={showToast} />}
        />
        <Route path="/register" element={<Registeration />} />
        <Route
          path="/my-account"
          element={<Account setPopUp={setPopUp} showParentToast={showToast} />}
        />
        <Route path="/product/:productCode" element={<Product />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
